import type { AiListingAutofillResponse } from '../types/aiListingAutofill';
import type { ResponseType } from '../types/responses';

import { apiClient } from './apiClient';

export const aiListingAutofillProvider = {
  autofillListingFromText: (sourceText: string): Promise<ResponseType<AiListingAutofillResponse>> =>
    apiClient<AiListingAutofillResponse>('/ai-listing/autofill', 'POST', { sourceText }),
};
